/**
 * EntityTypeEntityDropdownSearches
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';

// Components
import EntityDropdownSearch from '../EntityDropdownSearch';

// Selectors
import { selectIds } from './selectors';

interface OwnProps {
    multiple?: boolean;
    offset?: number;
    limit?: number;
    clearPageOnChange?: boolean;
}

interface ConnectedProps {
    ids: string[];
}

type Props = OwnProps & ConnectedProps;

export class EntityTypeEntityDropdownSearches extends React.PureComponent<
    Props
> {
    render(): React.ReactNode {
        const { ids, ...props } = this.props;

        return ids.map(id => (
            <div
                key={id}
                className="page-title-and-filters-button-wrapper-dropdown-wrapper"
            >
                <EntityDropdownSearch entityTypeId={id} {...props} />
            </div>
        ));
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    ids: selectIds
});

export default connect(mapStateToProps)(EntityTypeEntityDropdownSearches);
